export const GRID_CONFIG = {
    noDataText: "No Actions",
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
        enabled: true,
        allowSearch: true,
        mode: "select"
    },

    headerFilter: {
        visible: true
    },
    sorting: {
        mode: "none"
    },
    grouping: {
        contextMenuEnabled: true
    },
    searchPanel: {
        visible: true
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
        visible: true,
        applyFilter: "auto"
    },
    paging: {
        pageSize: 7
    },
    pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [7, 14, 28, 30],
        showInfo: true
    },
    export: {
        enabled: true,
        fileName: "Actions"
    },
    editing: {
        mode: "batch",
        allowUpdating: true,
        allowAdding: true,
        allowDeleting: true,
        useIcons: true
    },
   
    onToolbarPreparing: function (e) {
        var dataGrid = e.component;
        var toolbarItems = e.toolbarOptions.items;
        // Adds a new item
        toolbarItems.unshift({
            location: "after",
            widget: "dxButton",
            options: {
                icon: "refresh",
                hint: "Refresh",
                onClick: function () {
                    dataGrid.refresh();
                }
            }
        });
    }
}

export const COL_DEF = [{
    dataField: "id",
    caption: "ID",
    dataType: "number",
    visible: false,
    allowEditing: false,
    showInColumnChooser: false
}, {
        dataField: "metricDate",
    caption: "Maintenance Date",
    dataType: "date",
    format: "shortDate",
    validationRules: [{
        type: "required",
        message: "Date is required"
    }],
    editorOptions:{ useMaskBehavior: true }
}, {
    dataField: "reasonCode",
    caption: "Reason",
    width: 150,
    lookup: {
        dataSource: [],
        valueExpr: "reasonCode",
        displayExpr: "reasonCode"
    },
    validationRules: [{
        type: "required"
    }],
}, {
    dataField: "plan",
    caption: "Target (Mins)",
    dataType: "number",
    format: "#,##0",
    //visible: false
}, {
        dataField: "actual",
        caption: "Actual (Mins)",
        dataType: "number",
        format: "#,##0"
    }];

export const CHART_CONFIG = {
    palette: "Harmony Light",
    title: "Downtime Reason",
    argumentAxis: {
        label: {
            overlappingBehavior: "stagger"
        }
    },
   
    valueAxis: [{
        name: "Downtime",
        position: "left",
        tickInterval: 10
    }, {
        name: "percentage",
        position: "right",
        showZero: true,
        label: {
            customizeText: function (info) {
                return info.valueText + "%";
            }
        },

        tickInterval: 20,
        valueMarginsEnabled: false
    }],
    commonSeriesSettings: {
        argumentField: "reasonCode"
    },
    series: [{
        type: "bar",
        valueField: "actual", 
       // valueField: "oranges",

        axis: "Downtime",
        name: "Downtime",
        color: "#dc202e"
    }, {
        type: "spline",
            valueField: "cumulative",
            //valueField: "oranges",

        axis: "percentage",
        name: "Cumulative percentage",
        color: "#6b71c3"
    }],
    legend: {
        verticalAlignment: "top",
        horizontalAlignment: "center"
    }
}